export enum EPropertyType {
    CONFIG = 'config',
    COMPONENT = 'component'
}

export const EPropertyTypeValues = [EPropertyType.CONFIG, EPropertyType.COMPONENT]

export const EPropertyTypeLabels = {
    [EPropertyType.CONFIG]: 'enum.propertyType.config',
    [EPropertyType.COMPONENT]: 'enum.propertyType.component'
}
